
import { Component, Vue } from 'vue-property-decorator'

import { Beacon } from '@/types/Beacon'
import beaconModule from '@/store/beacon'

import ContentList from '@/components/listView/ContentList.vue'
import BeaconEditor from '@/components/beacon/BeaconEditor.vue'
import { ListType } from '@/utils/enums'

@Component({
  name: 'BeaconList',
  components: {
    ContentList,
    BeaconEditor
  }
})
class BeaconList extends Vue {
  private listType = ListType
  private showEditor = false

  private get storeModule() {
    return beaconModule
  }

  private get beacons(): Beacon[] {
    return beaconModule.beacons
  }

  private get headers() {
    return [
      { text: 'UUID', value: 'uuid' },
      { text: 'Major', value: 'major' },
      { text: 'Minor', value: 'minor' }
    ]
  }

  private setBeacon(beacon: Beacon): void {
    beaconModule.setBeacon(beacon)
    ;(this.$refs.beaconDialog as any).toggleDialog()
  }
}

export default BeaconList
